export default __webpack_public_path__ + "static/media/every-swap.436485f2.png";